import React from 'react';
import AppBanner from '../components/Banner/AppBanner';
import AppFeatures from '../components/Features/AppFeatures';
import AppWork from '../components/Service/AppWork';
import ScreenshowCase from '../components/ScreenshowCase';
import AppGetstarted from '../components/AppGetstarted';
import AppTeam from '../components/Team/AppTeam';
import ServiceData from '../components/Service/ServiceData';
import FooterData from '../components/Footer/FooterData';
import Footer from "../components/Footer/Footer";
import Testimonial from "../components/Testimonial/Testimonial";
import OnepageMenu from "../components/OnepageMenu";
import CloudServiceTab from "../components/Service/Sservice/CloudServiceTab";
import DeveloperTab from "../components/DeveloperTab";
import SecurityCustomerLogo from "../components/SecurityCustomersLogo";
import HostingActionTwo from "../components/HostingActionTwo";
import Stats from "../components/Timeline/Stats";

const Landing = () => {
    return (
        <div className="body_wrapper">
            {/*Navigator*/}
            <OnepageMenu slogo="sticky_logo" mClass="menu_four" nClass="w_menu" />
            {/*First Page*/}
            <AppBanner/>
            {/*Intro*/}
            <AppFeatures/>
            {/*Services*/}
            <AppWork ServiceData={ServiceData}/>
            {/*Stats*/}
            <Stats/>
            {/*Domain*/}
            <CloudServiceTab/>
            {/*Process Timeline*/}
            <HostingActionTwo/>
            {/*Technologies*/}
            <SecurityCustomerLogo/>
            {/*Documents*/}
            {/*Designs : Poster, System Diagram*/}
            <DeveloperTab/>
            {/*Reviews*/}
            <Testimonial tClass="testimonial_area sec_pad" FooterData={FooterData}/>
            {/*Screenshots*/}
            <ScreenshowCase/>
            {/*Download App*/}
            <AppGetstarted/>
            {/*Team*/}
            <AppTeam/>
            {/*Footer*/}
            <Footer FooterData={FooterData}/>
        </div>
    )
}
export default Landing;
